import {
  AdvertiserDisclosure,
  Box,
  CheckboxOption,
  Select,
} from '@nerdwallet/currency';
import { ProductType } from '@nerdwallet/currency/dist/components/AdvertiserDisclosure/AdvertiserDisclosureMessage';
import get from 'lodash/get';
import set from 'lodash/set';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useBuilder } from '~/app/lib/redux/selectors/builder-selector';
import { useDynamicGrid } from '~/app/lib/redux/selectors/dynamic-grid-selector';
import { ColorDropdown } from '~/app/lib/color-picker/color-picker';
import { updateComponent } from '../../dynamic-grid-helpers';
import styles from './advertiser-disclosure-component.module.scss';

export const DynamicAdvertiserDisclosureComponent = ({
  onBackground = true,
  type,
  textColor,
}: {
  onBackground?: boolean;
  type?: string;
  textColor?: string;
}) => {
  return (
    <div className={styles.advertiserDisclosure} style={{ color: textColor }}>
      <AdvertiserDisclosure
        onBackground={onBackground}
        type={type as ProductType}
      />
    </div>
  );
};

const typeOptions = [
  { label: 'Credit cards', value: 'credit_cards' },
  { label: 'Investing', value: 'investing' },
];

const getInitialState = (
  currentComponent: any,
  componentPath: string,
  field: string,
  initialValue: any
) => {
  return get(currentComponent, `props.${componentPath}.${field}`, initialValue);
};

export const DynamicAdvertiserDisclosureForm = () => {
  const dispatch = useDispatch();
  const { flatOutline, selected: selectedComponentId } = useBuilder();
  const { componentPath } = useDynamicGrid();
  const currentComponent = flatOutline?.[selectedComponentId];
  const [type, setType] = useState('');
  const [onBackground, setOnBackground] = useState(true);
  const [textColor, setTextColor] = useState('');
  const handleUpdateComponent = useCallback(
    (field: string, value: string | boolean | number) => {
      set(currentComponent, `props.${componentPath}.${field}`, value);
      dispatch(updateComponent(currentComponent));
    },
    [currentComponent, componentPath, dispatch]
  );

  const handleTextColorChange = (color: string) => {
    handleUpdateComponent('textColor', color);
    setTextColor(color);
  };

  const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setType(e.target.value);
    handleUpdateComponent('type', e.target.value);
  };

  const handleOnBackgroundChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOnBackground(e.target.checked);
    handleUpdateComponent('onBackground', e.target.checked);
  };

  useEffect(() => {
    setType(getInitialState(currentComponent, componentPath, 'type', ''));
    setOnBackground(
      getInitialState(currentComponent, componentPath, 'onBackground', true)
    );
  }, [currentComponent, componentPath, setType, setOnBackground]);

  return (
    <Box paddingY={2}>
      <Box paddingY={2}>
        <Select
          fullWidth
          value={type}
          onChange={handleTypeChange}
          label="Type"
          options={typeOptions}
        />
      </Box>
      <Box paddingY={2}>
        <CheckboxOption
          label="On a colorful/dark background?"
          checked={onBackground}
          onChange={handleOnBackgroundChange}
        />
      </Box>
      <Box paddingY={2}>
        <ColorDropdown
          label="Text Color"
          initialColor={textColor}
          onChange={handleTextColorChange}
        />
      </Box>
    </Box>
  );
};
